import React from 'react';
import PropTypes from 'prop-types';

import QuarterPolygonMap from '../../../../../components/QuarterPolygonMap';

const Sector = ({ property, quarterId, quarterDescription, quarterMapDisplay, printMode }) => {
  return (
    <div className='flex flex-col gap-8' data-testid='Sector'>
      <p className='h2 mx-auto text-center'>Votre <span className='text-ih-blue'>secteur</span> </p>

      <div className='flex flex-col md:flex-row items-center gap-8 md:w-3/4 mx-auto text-ih-indigo'>
        <div className={`w-full flex flex-col gap-5 ${quarterMapDisplay ? '' : 'text-center'}`}>
          <p className='h3'>Quelques mots sur votre secteur</p>
          <p className={`whitespace-pre-line ${quarterMapDisplay ? '' : 'md:w-2/3 mx-auto'}`}>{quarterDescription}</p>
        </div>

        {quarterMapDisplay && !printMode &&
          <div className='w-full' data-testid='quarterMap'>
            <QuarterPolygonMap
              quarterId={quarterId}
              center={{ lat: property.lat, lng: property.lng }}
              fixed
            />
          </div>
        }
      </div>
    </div>
  );
}

export default Sector;

// PropTypes
Sector.propTypes = {
  property: PropTypes.object.isRequired,
  quarterId: PropTypes.number,
  quarterDescription: PropTypes.string,
  quarterMapDisplay: PropTypes.bool,
}
